module.exports = __webpack_public_path__ + "img/要求工学論2020_4_11.6549636e.png";